export const bodyScrollLock = () => {
  document.body.classList.add('prevent-scroll');
};

export const bodyScrollUnLock = () => {
  document.body.classList.remove('prevent-scroll');
};
